// extracted by mini-css-extract-plugin
module.exports = {"tags":"styles-module__tags___JFdcF","smallTags":"styles-module__smallTags___1TCzn","tag":"styles-module__tag___2NdI1"};